/*
 * Lanificio, Black Friday 2026: neem een vriend mee (€50 extra, max één keer).
 * Hoort bij sections/lan-black-friday-vriend.liquid en snippets/lan-bf-link.liquid.
 *
 * - Iedereen die zich op de BF list (V7MjAQ) aanmeldt, krijgt een vaste code:
 *   FNV-1a (32 bit) over het e-mailadres in kleine letters, 6 tekens uit
 *   23456789ABCDEFGHJKLMNPQRSTUVWXYZ. Zelfde e-mail = zelfde code, dus de
 *   bestaande lijst kan achteraf dezelfde code krijgen.
 * - Komt iemand binnen via ?ref=CODE, dan onthoudt de browser die code en gaat
 *   hij bij de aanmelding mee als "BF aangebracht door".
 * - De eigenschappen gaan mee in elke aanmelding op de BF list op deze pagina
 *   (opening, gastenboek en dit blok): fetch naar a.klaviyo.com/client/
 *   subscriptions wordt hier aangevuld, de rest van de aanmelding blijft gelijk.
 */
(function () {
  'use strict';

  /* Ook geladen door sections/lan-textuur-popup.liquid: maar één keer draaien,
     anders wordt fetch twee keer aangevuld. */
  if (window.lanBfVriend) return;
  window.lanBfVriend = true;

  var BF_LIST = 'V7MjAQ';
  var BASIS = 'https://lanificio.nl/pages/black-friday?ref=';
  var TEKENS = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  var CODE_RE = /^[2-9A-HJ-NP-Z]{6}$/;
  var KEY_REF = 'lbf_ref';
  var KEY_MIJN = 'lbf_mijn_code';

  function lees(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function schrijf(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) { /* geen opslag: dan alleen voor deze pagina */ }
  }

  function utf8(str) {
    if (window.TextEncoder) return new TextEncoder().encode(str);
    var s = unescape(encodeURIComponent(str));
    var out = [];
    for (var i = 0; i < s.length; i++) out.push(s.charCodeAt(i));
    return out;
  }

  function maakCode(email) {
    var bytes = utf8(String(email).trim().toLowerCase());
    var h = 0x811c9dc5;
    for (var i = 0; i < bytes.length; i++) {
      h ^= bytes[i];
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    var code = '';
    for (var k = 0; k < 6; k++) {
      code += TEKENS.charAt(h & 31);
      h >>>= 5;
    }
    return code;
  }

  /* ---------- Binnenkomen via een link ---------- */

  var mijnCode = lees(KEY_MIJN);
  try {
    var ref = new URLSearchParams(window.location.search).get('ref');
    ref = ref ? ref.trim().toUpperCase() : '';
    if (CODE_RE.test(ref) && ref !== mijnCode) schrijf(KEY_REF, ref);
  } catch (e) { /* oude browser: geen koppeling */ }

  function vriendProps(code) {
    var props = {
      'BF vriendcode': code,
      'BF vriendlink': BASIS + code
    };
    var ref = lees(KEY_REF);
    if (ref && CODE_RE.test(ref) && ref !== code) {
      props['BF aangebracht door'] = ref;
      props['BF aangebracht op'] = new Date().toISOString();
    }
    return props;
  }

  /* ---------- Aanmeldingen aanvullen ---------- */

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('a.klaviyo.com/client/subscriptions') !== -1 && init && typeof init.body === 'string') {
          var body = JSON.parse(init.body);
          var list = body.data.relationships.list.data.id;
          var attrs = body.data.attributes.profile.data.attributes;
          if (list === BF_LIST && attrs && attrs.email) {
            var code = maakCode(attrs.email);
            var props = attrs.properties || {};
            var extra = vriendProps(code);
            for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
            attrs.properties = props;
            var nieuw = {};
            for (var j in init) if (Object.prototype.hasOwnProperty.call(init, j)) nieuw[j] = init[j];
            nieuw.body = JSON.stringify(body);
            return origFetch.call(window, input, nieuw).then(function (res) {
              if (res && res.status === 202) klaar(code);
              return res;
            });
          }
        }
      } catch (e) { /* aanvullen mag aanmelden nooit breken */ }
      return origFetch.apply(window, arguments);
    };
  }

  /* ---------- De link tonen ---------- */

  /* Eén aanmeldplek: de opening en het gastenboek (assets/lan-black-friday.js).
     Elk [data-vr-blok] toont de eigen link met Kopieer en WhatsApp:
     - in de opening en het gastenboek (snippets/lan-bf-link.liquid), binnen
       "Je staat op de lijst", dus pas zichtbaar na een geslaagde aanmelding;
     - in het vriendenblok (#vriend) zodra de code bekend is. Zonder code staat
       daar een knop naar #gastenboek ([data-vr-open]). */

  var root;

  function deeltekst(code) {
    var tekst = root ? root.getAttribute('data-vr-deeltekst') : '';
    return (tekst || 'Bij Lanificio kies je met Black Friday een week eerder, met korting op elk kleed. Via mijn link kom je op de lijst:') + ' ' + BASIS + code;
  }

  function toon(code) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vr-blok]'), function (blok) {
      var linkEl = blok.querySelector('[data-vr-link]');
      var waEl = blok.querySelector('[data-vr-wa]');
      if (linkEl) linkEl.textContent = BASIS.replace('https://', '') + code;
      if (waEl) waEl.href = 'https://wa.me/?text=' + encodeURIComponent(deeltekst(code));
      blok.hidden = false;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vr-open]'), function (el) {
      el.hidden = true;
    });
  }

  function klaar(code) {
    mijnCode = code;
    schrijf(KEY_MIJN, code);
    schrijf(KEY_REF, null);
    toon(code);
  }

  function kopieer(knop) {
    if (!mijnCode) return;
    var tekst = BASIS + mijnCode;
    var gelukt = function () {
      var oud = knop.getAttribute('data-tekst') || knop.textContent;
      knop.setAttribute('data-tekst', oud);
      knop.textContent = knop.getAttribute('data-gekopieerd') || 'Gekopieerd';
      setTimeout(function () { knop.textContent = oud; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(tekst).then(gelukt, function () { window.prompt('', tekst); });
    } else {
      window.prompt('', tekst);
    }
  }

  function init() {
    root = document.querySelector('[data-lbf-vriend]');
    if (mijnCode && CODE_RE.test(mijnCode)) toon(mijnCode);
    document.addEventListener('click', function (e) {
      var knop = e.target.closest && e.target.closest('[data-vr-kopieer]');
      if (knop) kopieer(knop);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
